import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from "@auth0/auth0-react";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";
import { AuthProvider } from "./context/AuthContext";
import { EnvironmentProvider } from "./context/EnvironmentContext";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <EnvironmentProvider>
        <AuthProvider>
          <Auth0Provider
            domain="dev-s2gzdni2zj4o1w0s.us.auth0.com"
            clientId="3C9Znu46ybisuXJbZZY7ZxbaRbWTCcR7"
            authorizationParams={{ redirect_uri: window.location.origin + "/home" }}
          >
            <App />
          </Auth0Provider>
        </AuthProvider>
      </EnvironmentProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
